import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TylerState, useTylerStateUpdate } from '../../utils/TylerState';

const PROMOS = [
    {
        title: 'Plan Your Retirement',
        description: 'Our advanced retirement planner handles RRSP, TFSA, CPP, OAS, and Social Security. See exactly when you can retire.',
        path: '/retirement',
        cta: 'Try the Retirement Planner'
    },
    {
        title: 'Buying a Home?',
        description: 'Compare renting vs buying with our housing calculator. See the true cost of homeownership over 25 years.',
        path: '/housing',
        cta: 'Try the Housing Calculator'
    },
    {
        title: 'Car Cost Calculator',
        description: 'Buy vs lease vs finance? Compare total costs side-by-side and see which option saves you the most.',
        path: '/car',
        cta: 'Try the Car Calculator'
    },
    {
        title: 'Income Tax Estimator',
        description: 'Estimate your federal and provincial/state income taxes. See your effective tax rate and take-home pay.',
        path: '/tax-tools',
        cta: 'Try the Tax Calculator'
    },
];

const CrossPromoModal: React.FC = () => {
    useTylerStateUpdate();
    const [show, setShow] = useState(false);
    const [promo, setPromo] = useState(PROMOS[0]);

    useEffect(() => {
        // Only for non-authenticated users
        const user = TylerState.user;
        if (user) return;

        // Only once per session
        const alreadyShown = sessionStorage.getItem('larry_promo_shown');
        if (alreadyShown) return;

        // Every 60 seconds, 1/10 chance
        const interval = setInterval(() => {
            if (sessionStorage.getItem('larry_promo_shown')) {
                clearInterval(interval);
                return;
            }

            if (Math.random() < 0.1) {
                const randomPromo = PROMOS[Math.floor(Math.random() * PROMOS.length)];
                setPromo(randomPromo);
                setShow(true);
                sessionStorage.setItem('larry_promo_shown', 'true');
                clearInterval(interval);
            }
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    if (!show) return null;

    return (
        <div className="promo-modal-overlay" onClick={() => setShow(false)}>
            <div className="promo-modal" onClick={e => e.stopPropagation()}>
                <h3>{promo.title}</h3>
                <p>{promo.description}</p>
                <Link to={promo.path} className="promo-cta" onClick={() => setShow(false)}>
                    {promo.cta}
                </Link>
                <button className="promo-dismiss" onClick={() => setShow(false)}>
                    No thanks, just here for sports
                </button>
            </div>
        </div>
    );
};

export default CrossPromoModal;
